import './lib/shims'
import { initialize } from './logger'
import './models/relationships'

if (document.location.hostname === 'localhost') {
  initialize()
}
